import { Collapse, Typography } from 'antd';
import { memo } from 'react';
import { resolveAssetUrl } from '../../../utils/resolveAssetUrl';
import Coupon from '../Coupon';
import { useForm } from '../context';
import { getFrequency, moneyMask } from '../helper';

const Header = memo(() => {
  const { getTotal, items, isRecurrence, firstItem, installments } = useForm();

  const hasOrderBump = !!items.find((item) => item.type === 'order_bump');

  const totalValue = (isRecurrence ? firstItem.amount * firstItem.quantity : getTotal()) / 100;
  const maxInstallment = installments?.[installments?.length - 1]?.installment ?? 0;
  const installmentValue = installments?.[installments?.length - 1]?.value ?? 0;

  const hasEnrollmentFee = items.some((item) => item.type == 'enrollment_fee');
  const validItems = items.filter(
    (item) => !hasEnrollmentFee || ['enrollment_fee', 'order_bump'].includes(item.type)
  );

  const totalDiscountAmount = validItems.reduce((acc, item) => {

    if (item.couponItem) {
      return acc + (item.amount - item.couponItem.amount) * item.quantity;
    }
    return acc;
  }, 0) / 100;

  const enrollmentFee = items.find((item) => item.type === 'enrollment_fee');

  return (
    <div>
      <div className="w-full flex items-center gap-4 mb-2">
        {firstItem?.image && (
          <img
            className="rounded-lg w-full max-w-24 sm:max-w-32 aspect-square object-cover"
            src={resolveAssetUrl(firstItem?.image)}
          />
        )}

        <div className="flex flex-col gap-1">
          <h1 className="text-base sm:text-lg leading-tight m-0 font-medium text-black">{firstItem?.description}</h1>

          {!isRecurrence && (
            <div className="text-gray-600">
              Em até {maxInstallment}x de{' '}
              <span className="text-lg font-medium">R$ {moneyMask.apply(installmentValue)}</span> ou{' '}
              <span className="text-lg font-medium">
                {totalDiscountAmount == 0 && <>R$ {moneyMask.apply(totalValue)}</>}
                {totalDiscountAmount > 0 && (
                  <>
                    <s>R$ {moneyMask.apply(totalValue + totalDiscountAmount)}</s>{' '}
                    R$ {moneyMask.apply(totalValue)}
                  </>
                )}
              </span>{' '}
              à vista.
            </div>
          )}

          {isRecurrence && enrollmentFee && maxInstallment > 1 && installmentValue > 0 && (
            <div className="text-gray-600">
              <strong className="font-medium">{enrollmentFee.description}</strong> em até {maxInstallment}x de{' '}
              <span className="text-lg font-medium text-black">R$ {moneyMask.apply(installmentValue)}</span> ou{' '}
              <span className="text-lg font-medium text-black">
                {totalDiscountAmount == 0 && <>R$ {moneyMask.apply(getTotal() / 100)}</>}
                {totalDiscountAmount > 0 && (
                  <>
                    <s>R$ {moneyMask.apply((getTotal()/ 100) + totalDiscountAmount)}</s>{' '}
                    R$ {moneyMask.apply(getTotal() / 100)}
                  </>
                )}</span>{' '}
                à vista.
            </div>
          )}

          {isRecurrence && enrollmentFee && maxInstallment === 1 && installmentValue > 0 && (
            <div className="text-gray-600">
              <Typography.Title level={5} className="text-lg">
                {enrollmentFee.description?.toUpperCase()}
              </Typography.Title>
              <span className="text-lg font-medium">R$ {moneyMask.apply(getTotal() / 100)}</span> à vista.
            </div>
          )}

          {isRecurrence && enrollmentFee && maxInstallment === 1 && installmentValue == 0 && (
            <div className="text-gray-600">
              <Typography.Title level={5} className="text-lg">
                {enrollmentFee.description?.toUpperCase()}
              </Typography.Title>
              <span className="text-lg font-medium text-green-700">Grátis</span>
            </div>
          )}

          {isRecurrence && (
            <div className="text-gray-600">
              <h2 className="text-base font-medium">Assinatura</h2>

              <span className="text-lg text-black font-medium">
                {!firstItem?.couponItem && <>R$ {moneyMask.apply(firstItem?.amount / 100)}</>}
                {firstItem?.couponItem && <><s>R$ {moneyMask.apply(firstItem?.amount / 100)}</s>{' '}R$ {moneyMask.apply((firstItem?.couponItem?.amount ?? firstItem.amount) / 100)}</>}
              </span>

              <div className="text-sm text-gray-500">
                a cada {firstItem?.recurrenceInterval}{' '}
                {getFrequency(firstItem?.recurrenceFrequency, firstItem?.recurrenceInterval)}{' '}
                  <>
                    durante o período de {firstItem.recurrenceInterval * firstItem.recurrenceChargesQuantity}{' '}
                    {getFrequency(
                      firstItem?.recurrenceFrequency,
                      firstItem.recurrenceInterval * firstItem.recurrenceChargesQuantity
                    )}
                    .
                  </>
              </div>

              {hasOrderBump && !enrollmentFee && (
                <>
                  <Typography.Text className="block mt-2 text-sm text-gray-500">
                    Total: R$ {moneyMask.apply(getTotal() / 100)}{' '}
                  </Typography.Text>
                </>
              )}
            </div>
          )}

          <Coupon />
        </div>
      </div>

      {firstItem?.details && (
        <div className="sm:hidden">
          <Collapse
            ghost
            items={[
              {
                key: '1',
                label: 'Detalhes',
                children: (
                  <span
                    className="text-base details-container text-gray-500"
                    dangerouslySetInnerHTML={{ __html: firstItem?.details }}
                  />
                ),
              },
            ]}
          />
        </div>
      )}
    </div>
  );
});

export default Header;
